import { VesselData } from "../vessel-reg/vessel-data.model";
import { FishingEvent } from "./fishing-event.model";
import { LookupItem } from "./lookup-item.model";
import { DeliveryStatus } from "./trip.model";
import { Unloading } from "./unloading.model";


/**
 * Delivery model for HMS Albacore
 * All properties are specific to groundfish
 */
export class HMSDelivery {

  status: DeliveryStatus = DeliveryStatus.New;

  vessel: VesselData = new VesselData('', '');

  operatorName: string = '';

  //Unique identifier for each delivery
  deliveryID: string = '';

  //For HMS this is the arrival date, return date for Groundfish
  arrivalDate!: Date;

  //As above, arrival for HMS, return for Groundfish
  arrivalPort: LookupItem = new LookupItem('', 0);

  //List of associated Fishing Events/Sets, slightly different between HMS and Groundfish
  sets: FishingEvent[] = [];

  //Once received, this delivery will get a logbook id and received date, this received date is the original submission date
  logbookId!: string;
  receivedDate!: Date;

  //Logbook version starts at 1, Incremented upon each submission of edits
  //submissionDate is the date of the most recently submitted edits
  logbookVersion: number = 1;
  submissionDate!: Date;  

  isNewDelivery: boolean = true;

  departureDate!: Date;

  departurePort: LookupItem = new LookupItem('', 0);

  unloading: Unloading[] = [];

  localLandingGUID!: string;


  updateValue(form: any) {
    this.vessel = form.vessel;
    this.operatorName = form.operator;
    this.arrivalDate = form.arrivalDate;
    this.arrivalPort = form.arrivalPort;
    this.departureDate = form.departureDate;
    this.departurePort = form.departurePort;
}

  setValues(delivery: any) {
    let d = delivery as HMSDelivery;
    this.operatorName = delivery.operatorName;
    this.vessel = new VesselData(d.vessel.vesselName, d.vessel.vesselCoastNumber);
    this.deliveryID = d.deliveryID;
    this.departureDate = d.departureDate;
    this.departurePort = LookupItem.transformAnonymous(d.departurePort);
    this.arrivalDate = d.arrivalDate ? new Date(d.arrivalDate) : this.arrivalDate;
    this.arrivalPort = LookupItem.transformAnonymous(d.arrivalPort);
    this.sets = d.sets.map(set => FishingEvent.transformAnonymous(set));
    this.unloading = d.unloading;
    this.logbookId = d.logbookId;
    this.receivedDate = delivery.receivedDate ? new Date(d.receivedDate) : this.receivedDate;
    this.logbookVersion = d.logbookVersion ?? 1;
    this.submissionDate = d.submissionDate; //not sure if this will be necessary for HMS
    this.localLandingGUID = d.localLandingGUID;
  }


  static transformAnonymous(anon: any): HMSDelivery {
    let hms = new HMSDelivery();
    hms.isNewDelivery = anon.isNewDelivery ?? true;
    hms.operatorName = anon.operatorName ?? '';
    hms.vessel = anon.vessel ? new VesselData(anon.vessel.vesselName, anon.vessel.vesselCoastNumber) : new VesselData('', '');
    hms.status = anon.status;
    hms.deliveryID = anon.deliveryID;
    hms.arrivalDate = anon.arrivalDate;
    hms.arrivalPort = LookupItem.transformAnonymous(anon.arrivalPort);
    hms.sets = (anon.sets as any[]).map(s => FishingEvent.transformAnonymous(s));
    hms.logbookId = anon.logbookId;
    hms.receivedDate = anon.receivedDate;
    hms.logbookVersion = anon.logbookVersion;
    hms.submissionDate = anon.submissionDate;  
    hms.departureDate = anon.departureDate;
    hms.departurePort = LookupItem.transformAnonymous(anon.departurePort);
    hms.unloading = anon.unloading;
    hms.localLandingGUID = anon.localLandingGUID;
    hms.receivedDate = anon.receivedDate;

    return hms;
  }
}
